import { render } from "./EthereumChart.vue?vue&type=template&id=bffecbbe&scoped=true&ts=true"
import script from "./EthereumChart.vue?vue&type=script&lang=ts"
export * from "./EthereumChart.vue?vue&type=script&lang=ts"

import "./EthereumChart.vue?vue&type=style&index=0&id=bffecbbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bffecbbe"]])

export default __exports__